import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getI18n } from '../lib/i18n';
const KeyboardHint = ({ onClick }) => {
    const i18n = getI18n();
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    const shortcut = isMac ? '⌘K' : 'Ctrl+K';
    return (_jsx("div", { className: "eno-search-keyboard-hint", children: _jsxs("button", { className: "eno-search-keyhint", onClick: onClick, "aria-label": `${i18n.openSearchLabel} (${shortcut})`, title: `${i18n.openSearchLabel} (${shortcut})`, children: [_jsx("span", { children: i18n.searchButton }), _jsx("kbd", { children: shortcut })] }) }));
};
export default KeyboardHint;
